import router from '@/router'
import localforage from 'localforage'
import VueAnalytics from 'vue-analytics'
import { eventag } from '@/utils'

const url = 'https://ws.microcanales.es/eventos/registrar'
export default {
  actions: {
    async log_access (context, { event }) {
      return null
      const getters = context.getters
      const user = (getters.user || {})
      console.log({eventag})
      eventag({
        eventCategory: 'views',
        eventAction: 'log_access',
        eventLabel: event,
        value: user.id
      }, this)
      const ip = getters.ip
      const deviceId = getters.deviceId || await localforage.getItem('deviceId')
      const date = new Date().toISOString().split('T')[0]
      const date_hr = new Date().toISOString().replace('T', ' ').split('.')[0]
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          type: 'log_access',
          event,
          data: {
            user_id: (user || {}).id,
            device_id: deviceId,
            date: Date.now(),
            date_hr: date_hr,
            ip: ip,
            category: 'web'
          }
        })
      })
    },
    async log_banner ({ getters }, { event, banner_id }) {
      return null
      eventag({
        eventCategory: 'views',
        eventAction: 'log_banner',
        eventLabel: event,
        value: banner_id
      }, this)
      const user = getters.user || {}
      const date = new Date().toISOString().split('T')[0]
      const date_hr = new Date().toISOString().replace('T', ' ').split('.')[0]

      return fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          type: 'log_banner',
          event,
          data: {
            user_id: (user || {}).id,
            date: Date.now(),
            date_hr: date_hr,
            category: 'web',
            banner_id
          }
        })
      })
    },
    async log_video_views ({ getters }, { event, duration, program_slug }) {
      return null
      eventag({
        eventCategory: 'views',
        eventAction: 'log_video_views',
        eventLabel: event,
        value: program_slug
      }, this)
      const ip = getters.ip
      const deviceId = getters.deviceId || await localforage.getItem('deviceId')
      const user = getters.user || {}
      const date = new Date().toISOString().split('T')[0]
      const date_hr = new Date().toISOString().replace('T', ' ').split('.')[0]
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          type: 'log_video_views',
          event,
          data: {
            prefered_language_audio: 'es',
            prefered_language_subtitulos: 'es',
            user_id: (user || {}).id,
            date: Date.now(),
            date_hr: date_hr,
            category: 'web',
            duration,
            program_slug
          }
        })
      })
    }
  }
}
